import MyAccountView from './Pages/MyAccountView';
import MyAlertsView from './Pages/MyAlertsView';

import SearchResults from '../containers/SearchResults';

import BlockingPageView from './Pages/BlockingPageView';
import DashboardPageView from './Pages/DashboardPageView';
import HostnamesView from './Pages/Resources/HostnamesView';
import IPsView from './Pages/Resources/IPsView';
import LabelsPageView from './Pages/LabelsPageView';
import LocationsPageView from './Pages/LocationsPageView';
import LogdevView from './Pages/Resources/LogdevView';
import OrganizationPageView from './Pages/OrganizationPageView';
import OrganizationsPageView from './Pages/OrganizationsPageView';
import PipelinesPageView from './Pages/PipelinesPageView';
import ResourcesDashboard from './Pages/ResourcesDashboard';
import ResponderPage from './Pages/Dashboard/Responder';
import SecurityDashboard from './Pages/SecurityDashboard';
import SensorsPageView from './Pages/SensorsPageView';
import SubnetsPageView from './Pages/SubnetsPageView';
import TosView from './Pages/TosView';
import MonitorModePageView from './MonitorMode/MonitorModeView';
import UsersPageView2 from './Pages/UsersPageView2';
import NewReportPageView from './Pages/Reporting/new';
import BillingPageView from './Pages/BillingPageView';
import FindingsView, {defaultColumnFields as findingOutputFields} from './Pages/FindingsPageView';
import RulesView from './Pages/RulesPageView';

import SummaryDashboard from './Pages/SummaryDashboard';

import PopularReportsView from './Pages/PopularReports';

import CloudModulesView from './Pages/CloudModules';

import WelcomePageView from './Pages/WelcomePageView';

import ScheduledReportsView from './Pages/ScheduledReportsView';
import MSPAccountsPageView from './Pages/MSPAccountsPageView';
import MSPUsersPageView from './Pages/MSPUsersPageView';
import MSPResourcesPageView from './Pages/MSPResourcesPageView';
import MSPSettingsPageView from './Pages/MSPSettingsPageView';
import moment from 'moment-timezone';

export const childrenPageViews = [
  {
    component: WelcomePageView,
    route: 'getstarted/welcome',
    roles: ['*'],
    requirements: (state) => {
      return {
        integrations: {
          namespace: '/integration',
        },
        rules: {
          namespace: '/rule',
          resultParams: {
            page: {count: 20000}
          }
        },
      }
    },
  },
  {
    component: SummaryDashboard,
    route: 'dashboard/summary',
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    requirements: (state) => {
      return {
        constants: {
          namespace:'/constants'
        },
        integrations: {
          namespace: '/integration',
        },
        blockedEvents: {
          namespace:'/bq',
          queryParams: [
            {field:'query.id', value:24},
            {field:'created', operator:'gt', value:moment.utc().add(-6, 'months').startOf('minute').format("YYYY-MM-DDTHH:mm")},
          ]
        },
        logsTotal: {
          namespace:'/bq',
          queryParams: [
            {field:'query.id', value:100},
            {field:'created', operator:'gt', value:moment.utc().add(-6, 'months').startOf('minute').format("YYYY-MM-DDTHH:mm")},
          ]
        },
        threats: {
          namespace:'/bq',
          queryParams: [
            {field:'query.id', value:23},
            {field:'created', operator:'gt', value:moment.utc().add(-6, 'months').startOf('minute').format("YYYY-MM-DDTHH:mm")},
          ]
        },
        suspects: {
          namespace:'/bq',
          queryParams: [
            {field:'query.id', value:22},
            {field:'created', operator:'gt', value:moment.utc().add(-6, 'months').startOf('minute').format("YYYY-MM-DDTHH:mm")},
          ]
        },
        findings: {
          stale: 1,
          expire: 1,
          namespace:'/finding',
          queryParams: [
            { field: 'status', value: '0' },
            { refName: 'startTime', field:'created', operator:'lt', negate:true, value: moment.utc().add(-6, 'months').startOf('minute').format("YYYY-MM-DDTHH:mm") }
          ],
          resultParams: {
            orderBy: [{ key: 'created', value: -1 }],
            outputFields: ['owners','id','created','orgId','priority','shortId','name','analysis','type','category','confirmation','confirmationCompleted', 'escalation', 'escalationCompleted', 'mitigation', 'mitigationCompleted']
          }
        },
        rules: {
          namespace: '/rule',
          resultParams: {
            page: {count: 20000}
          }
        },
        savedQueries: {
          namespace: '/query',
          queryParams: [
            {field: 'namespace', operator:'eq', value: 'bq'},
          ],
          stale:1,
          expire: 1
        },
      }
    }
  },
  {
    route: 'dashboard/manager',
    component: DashboardPageView,
    roles: ['administrator']
  },
  {
    route: 'dashboard/resources',
    component: ResourcesDashboard,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    featureFlag: 'feature_flag_show_assets',
  },
  {
    route: 'dashboard/responder',
    component: ResponderPage,
    roles: ['responder'],
    requirements: (state) => {
      return {
        findings: {
          stale: 1,
          expire: 1,
          namespace:'/finding',
          queryParams: [
            { field: 'status', value: '0' },
            { refName: 'startTime', field:'created', operator:'lt', negate:true, value: moment.utc().add(-1, 'months').startOf('minute').format("YYYY-MM-DDTHH:mm") }
          ],
          resultParams: {
            orderBy: [{ key: 'created', value: -1 }]
          }
        },
        constants: {
          namespace:'/constants'
        }
      }
    },
  },
  {
    route: 'dashboard/security',
    component: SecurityDashboard,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    requirements: (state) => {
      return {
        savedQueries: {
          namespace: '/query',
          queryParams: [
            {field:'orgId', value: state.page.payload.orgId},
          ],
        },
      }
    },
  },
  {route: 'monitor-mode', component: MonitorModePageView},
  {
    route: 'settings/blocklists',
    component: BlockingPageView,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
  },
  {
    route: 'settings/locations',
    component: LocationsPageView,
    roles: ['administrator', 'manager'],
  },
  {
    route: 'settings/organization',
    component: OrganizationPageView,
    roles: ['administrator'],
  },
  {
    route: 'settings/organizations',
    component: OrganizationsPageView,
    roles: [],
    modes: ['admin'],
  },
  {
    route: 'settings/pipelines',
    component: PipelinesPageView,
    roles: [],
  },
  {
    route: 'settings/sensors',
    component: SensorsPageView,
    roles: ['administrator', 'manager'],
  },
  {
    route: 'settings/subnets',
    component: SubnetsPageView,
    roles: [],
    labs: true,
  },
  {
    route: 'settings/tags',
    component: LabelsPageView,
    roles: ['administrator', 'manager', 'responder'],
  },
  {
    route: 'settings/users',
    component: UsersPageView2,
    roles: ['administrator', 'manager'],
    requirements: (state) => {
      return {
        locations: {
          namespace:'/location',
          queryParams: [
            { field:'orgId', value: state.page.payload.orgId }
          ]
        }
      }
    }
  },
  {
    route: 'settings/cloudmodules',
    component: CloudModulesView,
    roles: ['administrator', 'manager'],
    requirements: (state) => {
      return {
        integrations: {
          namespace: '/integration',
        },
        integrationSchemas: {
          namespace: '/integrationSchema',
        },
        orgColumnStats: {
          namespace: '/orgColumnStats',
          queryParams: [
            { field: 'orgId', value: state.page.payload.orgId },
          ]
        }
      }
    }
  },
  {
    route: 'settings/billing',
    component: BillingPageView,
    roles: ['administrator', 'manager'],
    markets: [0, 30, 50] // direct, self-service, and referral only
  },
  {
    route: 'investigate/hostnames',
    component: HostnamesView,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    featureFlag: 'feature_flag_show_assets',
  },
  {
    route: 'investigate/ips',
    component: IPsView,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    featureFlag: 'feature_flag_show_assets',
  },
  {
    route: 'investigate/logdev',
    component: LogdevView,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    featureFlag: 'feature_flag_show_assets',
  },
  {
    route: 'investigate/subnets',
    component: ResourcesDashboard,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    featureFlag: 'feature_flag_show_assets',
  },
  {
    route: 'investigate/usernames',
    component: ResourcesDashboard,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    featureFlag: 'feature_flag_show_assets',
  },

  {
    route: 'reporting/events',
    redirect: 'reporting/builder',
  },
  {
    route: 'reporting/findings',
    component: FindingsView,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    requirements: (state) => {
      return {
        queries: {
          namespace:'/query',
          queryParams: [
            { field:'namespace', value: 'finding' },
          ]
        },
        findings: {
          stale: 1,
          expire: 1,
          namespace:'/finding',
          queryParams: [
            { refName: 'startTime', field:'created', operator:'gt', value: moment.utc().add(-1, 'months').startOf('minute').format("YYYY-MM-DDTHH:mm") },
            { refName: 'endTime', field:'created', operator:'lt', value: moment.utc().endOf('minute').format("YYYY-MM-DDTHH:mm:ss.SSS999") }
          ],
          resultParams: {
            outputFields: findingOutputFields,
            page: {count: 20000}
          }
        },
        users: {
          namespace:'/user',
        },
        constants: {
          namespace:'/constants'
        }
      }
    }
  },
  {
    route: 'reporting/popularreports',
    component: PopularReportsView,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    requirements: (state) => {
      return {
        savedQueries: {
          namespace: '/query',
          queryParams: [
            {field: 'namespace', operator:'eq', value: 'bq'}
          ]
        },
      }
    },
  },
  {
    route: 'reporting/results',
    component: SearchResults,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
  },
  {
    route: 'reporting/scheduledreports',
    component: ScheduledReportsView,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    requirements: (state) => {
      return {
        reports: {
          namespace:'/report',
        },
        savedQueries: {
          namespace: '/query',
          queryParams: [
            {field:'namespace', operator:'in', value: ['finding', 'bq']}
          ]
        },
      }
    }
  },
  {
    route: 'reporting/builder',
    component: NewReportPageView,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    requirements: (state) => {
      return {
        savedQueries: {
          namespace: '/query',
          queryParams: [
            {field: 'namespace', operator:'eq', value: 'bq'},
      
          ],
          resultParams: {
            orderBy: [{ key: 'name', value: 1 }]
          }
        },
        activeQuery: {
          namespace: '/bq',
          queryParams: [
            { refName: 'endTime', field:'created', operator:'lt', value: moment.utc().endOf('minute').format("YYYY-MM-DDTHH:mm:ss.SSS999") },
            { refName: 'startTime', field:'created', operator:'gt',  value: moment.utc().add(-4, 'hours').startOf('minute').format("YYYY-MM-DDTHH:mm") },
            { refName: 'selectedLogTypes', field:'type', operator:'in', value:[]}
          ],
          resultParams: {
            outputFields: ['type']
          }          
        },
        orgLogTypes: {
          namespace: '/logtype',
          resultParams: {
            outputFields: ['name']
          }   
        }
      }
    }
  },
  /*
  {
    route: 'reporting/legacy',
    component: ReportPageView,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    requirements: (state) => {
      return {
        logTypes: {
          namespace: '/logtype',
          stale:0,
        },
        columns: {
          namespace: '/column',
          stale:0,
        },
        savedQueries: {
          namespace: '/dataquery',
          queryParams: [
            {field: 'orgId', value: state.page.payload.orgId},
            {field:'dataSource', value: 'bq'}
          ],
          stale:1,
          expire: 1
        },
      }
    }
  },
  */
  {
    route: 'settings/rules',
    component: RulesView,
    roles: ['administrator', 'manager', 'responder', 'analyst'],
    requirements: (state) => {
      return {
        rules: {
          namespace: '/rule',
          resultParams: {
            page: {count: 10000}
          }
        },
        conditions: {
          namespace: '/condition',
          resultParams: {
            page: {count: 5000}
          }
        },
        actions: {
          namespace: '/action',
        },
        findingTypes: {
          namespace: '/constant/finding_type',
        },
      }
    }
  },
  {
    route: 'user/alertsettings',
    component: MyAlertsView,
    requirements: (state) => {
      return {
        users: {namespace: '/user'}
      }
    }
  },
  {
    route: 'user/myaccount', 
    component: MyAccountView
  }
  ,
  {
    route: 'user/tos',
     component: TosView
    },
  {
    route: 'mspportal/accounts', 
    component: MSPAccountsPageView,
    roles: ['administrator', 'responder']
  },
  {
    route: 'mspportal/users',     
    component: MSPUsersPageView,
    roles: ['administrator', 'responder']
  },
  {
    route: 'mspportal/settings',     
    component: MSPSettingsPageView,
    roles: ['administrator', 'responder']
  },
  {
    route: 'mspportal/resources',     
    component: MSPResourcesPageView,
    roles: ['administrator', 'responder']
  },
];
